import { useAtomValue } from 'jotai';
import { userPermissionKeysAtom } from '../Atoms';

/**
 * Whether the logged-in user holds a permission key, e.g. `practices.import`.
 *
 * Bind to the key of the action the control performs, never to a UI-specific
 * key invented for the purpose — that recreates the two-sources-of-truth problem
 * the feature flags already have. Where a control triggers several calls, gate
 * on the one that would fail.
 *
 * Answers `false` until the bootstrap payload lands. The shell holds rendering
 * until then, so in practice no consumer sees that state; it is the safe answer
 * regardless, and it is also what a failed bootstrap leaves behind.
 *
 * This is presentation only. The endpoint enforces the same key server-side, and
 * a permission belonging to a disabled module is answered more strongly still —
 * its endpoints do not exist.
 */
export default function useHasPermission(key) {
  const keys = useAtomValue(userPermissionKeysAtom);
  return Boolean(key) && Boolean(keys?.has(String(key).toLowerCase()));
}
